import React, { Component } from "react"
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, FormControl, FormHelperText, ThemeProvider } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import image from "../../../../assets/img/svg/Image.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import { getprojectbasicinfo, addprojectshipinfo, getprojectshipinfo, putprojectshipinfo } from "../../../../actions/AddNewProjectAction"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Delete from "../../../../assets/img/svg/delete.svg"
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import del from "../../../../assets/img/svg/Del.svg";
import { getSettingsFormat } from "../../../../actions/SettingsAction"
const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class AddSP extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            cancel: false,
            isEdit: false,
            isError1: false,
            isError2: false,
            isError3: false,
            isError4: false,
            isError5: false,
            isError6: false,
            isError7: false,
            isError8: false,
            isError9: false,
            isError10: false,
            isError11: false,
            isError12: false,
            isError13: false,
            isError14: false,
            isError15: false,
            ProjectName: "New Project",
            addData: {
                "Id": 0,
                "Name": "",
                "Type": "",
                "PortOfRegistry": "",
                "Builder": "",
                "ConstructionDate": "",
                "ClassificationSociety": "",
                "GrossTonnage": "",
                "NetTonnage": "",
                "LightShipWeight": "",
                "Length": "",
                "Breath": "",
                "Depth": "",
                "DesignDraught": "",
                "IMONumber": "",
                "DistinctiveNumber": "",
                "IMORegisteredOwnerId": "",
                "IMOCompanyId": "",
                "PhoneNumber": "",
                "Email": "",
                "DateofBeaching": "",
                "ProjectId": 0,
                "Modifiedby": "",
            }
        }
    };
    handleInputChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.state.addData[node] = e.target.value;
        this.setState({})
    };

    componentDidMount() {
        window.location.pathname === "/shipparticulars/add" ? this.state.isEdit = false : this.state.isEdit = true;
        this.state.ProjectName = localStorage.getItem("ProjectName");

        this.setState({})
        if (this.state.isEdit == false) {
            this.state.addData.ProjectId = parseInt(localStorage.getItem("addeditid"))

            this.setState({})
            if (localStorage.getItem("addeditid") != null) {
                this.getprojectshipinfo(localStorage.getItem("addeditid"))
            }
        }
        if (this.state.isEdit == true) {
            this.getprojectshipinfo(localStorage.getItem("DashId"))
            this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"))

            this.setState({})
        }
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
        this.props.dispatch(getSettingsFormat(this.state.addData.ProjectId))
    }

    getprojectshipinfo = (data) => {
        let apiUrl = API.ADDEDIT_SHIPINFO + data;
        // this.props.dispatch({type:"SHOW_LOADER",data:true})
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.addData = response?.data;
                    this.setState({})
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                } else {
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#SP .MuiListItemText-primary").removeClass("fw-bolder")
        $("#SPL").removeClass("active-color")
    }

    // sidebar = () => {
    //     if (this.state.isEdit == true) {
    //         this.props.navigate("/sidebareditproject");
    //     }
    //     else {
    //         this.props.navigate("/sidebaraddproject");
    //     }
    // }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            if (this.state.isEdit == true) {
                this.props.navigate("/sidebareditproject");
            }
            else {
                this.props.navigate("/sidebaraddproject");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (this.state.isEdit == true) {
            this.props.navigate("/sidebareditproject");
        }
        else {
            this.props.navigate("/sidebaraddproject");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })

        }
        $("#Ship1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#ShipParticulars1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#ShipParticulars").removeClass("d-none");
        $("#ShipParticulars").addClass("d-block");
        $("#SP .MuiListItemText-primary").addClass("fw-bolder");
        $("#SPL").addClass("active-color");
    };

    handleDateChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.setState({})
        if (e.target.value == "") {
            this.state.addData[node] = "";
            this.setState({});
        }
        else {
            this.state.addData[node] = e.target.value
            this.setState({});
        }
    };

    Save = () => {
        const { ProjectId, Name, Type, PortOfRegistry, ConstructionDate, ClassificationSociety, GrossTonnage, NetTonnage, LightShipWeight, Length, Breath, Depth, DesignDraught, IMONumber, DistinctiveNumber, DateofBeaching } = this.state.addData;
        if (ProjectId !== 0 || ProjectId !== undefined) {

            if (Name.trim() === "") {
                this.state.isError1 = true;
                this.state.addData.Name = this.state.addData.Name.trim();
                this.setState({})
            }
            else {
                this.state.isError1 = false;
                this.state.addData.Name = this.state.addData.Name.trim();
                this.setState({})
            }
            if (Type.trim() === "") {
                this.state.isError2 = true;
                this.state.addData.Type = this.state.addData.Type.trim();
                this.setState({})
            }
            else {
                this.state.isError2 = false;
                this.state.addData.Type = this.state.addData.Type.trim();
                this.setState({})
            }
            if (PortOfRegistry.trim() === "") {
                this.state.isError3 = true;
                this.state.addData.PortOfRegistry = this.state.addData.PortOfRegistry.trim();
                this.setState({})

            }
            else {
                this.state.isError3 = false;
                this.state.addData.PortOfRegistry = this.state.addData.PortOfRegistry.trim();
                this.setState({})
            }
            if (ConstructionDate.trim() === "") {
                this.state.isError4 = true;
                this.state.addData.ConstructionDate = this.state.addData.ConstructionDate.trim();

                this.setState({})
            }
            else {
                this.state.isError4 = false;
                this.state.addData.ConstructionDate = this.state.addData.ConstructionDate.trim();

                this.setState({})
            }
            if (ClassificationSociety.trim() === "") {
                this.state.isError5 = true;
                this.state.addData.ClassificationSociety = this.state.addData.ClassificationSociety.trim();
                this.setState({})
            }
            else {
                this.state.isError5 = false;
                this.state.addData.ClassificationSociety = this.state.addData.ClassificationSociety.trim();
                this.setState({})
            }
            if (GrossTonnage.trim() === "") {
                this.state.isError6 = true;
                this.state.addData.GrossTonnage = this.state.addData.GrossTonnage.trim();
                this.setState({})
            }
            else {
                this.state.isError6 = false;
                this.state.addData.GrossTonnage = this.state.addData.GrossTonnage.trim();
                this.setState({})
            }
            if (NetTonnage.trim() === "") {
                this.state.isError7 = true;
                this.state.addData.NetTonnage = this.state.addData.NetTonnage.trim();
                this.setState({})
            }
            else {
                this.state.isError7 = false;
                this.state.addData.NetTonnage = this.state.addData.NetTonnage.trim();
                this.setState({})
            }
            if (LightShipWeight.trim() === "") {
                this.state.isError8 = true;
                this.state.addData.LightShipWeight = this.state.addData.LightShipWeight.trim();
                this.setState({})
            }
            else {
                this.state.isError8 = false;
                this.state.addData.LightShipWeight = this.state.addData.LightShipWeight.trim();
                this.setState({})
            }
            if (Length.trim() === "") {
                this.state.isError9 = true;
                this.state.addData.Length = this.state.addData.Length.trim();
                this.setState({})
            }
            else {
                this.state.isError9 = false;
                this.state.addData.Length = this.state.addData.Length.trim();
                this.setState({})
            }
            if (Breath.trim() === "") {
                this.state.isError10 = true;
                this.state.addData.Breath = this.state.addData.Breath.trim();
                this.setState({})
            }
            else {
                this.state.isError10 = false;
                this.state.addData.Breath = this.state.addData.Breath.trim();
                this.setState({})
            }
            if (Depth.trim() === "") {
                this.state.isError11 = true;
                this.state.addData.Depth = this.state.addData.Depth.trim();
                this.setState({})
            }
            else {
                this.state.isError11 = false;
                this.state.addData.Depth = this.state.addData.Depth.trim();
                this.setState({})
            }
            if (DesignDraught.trim() === "") {
                this.state.isError12 = true;
                this.state.addData.DesignDraught = this.state.addData.DesignDraught.trim();
                this.setState({})
            }
            else {
                this.state.isError12 = false;
                this.state.addData.DesignDraught = this.state.addData.DesignDraught.trim();
                this.setState({})
            }
            if (IMONumber.trim() === "") {
                this.state.isError13 = true;
                this.state.addData.IMONumber = this.state.addData.IMONumber.trim();
                this.setState({})
            }
            else {
                this.state.isError13 = false;
                this.state.addData.IMONumber = this.state.addData.IMONumber.trim();
                this.setState({})
            }
            if (DistinctiveNumber.trim() === "") {
                this.state.isError14 = true;
                this.state.addData.DistinctiveNumber = this.state.addData.DistinctiveNumber.trim();
                this.setState({})
            }
            else {
                this.state.isError14 = false;
                this.state.addData.DistinctiveNumber = this.state.addData.DistinctiveNumber.trim();
                this.setState({})
            }
            if (DateofBeaching === "") {
                this.state.isError15 = true;
                this.setState({})
            }
            else {
                this.state.isError15 = false;
                this.setState({})
            }
            if (this.state.addData.Name !== "" && this.state.addData.Type !== "" && this.state.addData.PortOfRegistry !== "" && this.state.addData.ConstructionDate !== "" && this.state.addData.ClassificationSociety !== "" && this.state.addData.GrossTonnage !== "" && this.state.addData.NetTonnage !== "" && this.state.addData.LightShipWeight !== "" && this.state.addData.Length !== "" && this.state.addData.Breath !== "" && this.state.addData.Depth !== "" && this.state.addData.DesignDraught !== "" && this.state.addData.IMONumber !== 0 && this.state.addData.DistinctiveNumber !== "" && this.state.addData.DateofBeaching !== "") {
                localStorage.setItem("LightshipWeight", LightShipWeight)
                this.state.addData.Modifiedby = localStorage.getItem("UserRoles");
                if (this.state.addData.Email != "" || this.state.addData.Email != null) {
                    this.state.addData.Email = this.state.addData.Email.trim();
                }
                if (this.state.addData.IMORegisteredOwnerId != "" || this.state.addData.IMORegisteredOwnerId != null) {
                    this.state.addData.IMORegisteredOwnerId = this.state.addData.IMORegisteredOwnerId.trim();
                }
                if (this.state.addData.IMOCompanyId != "" || this.state.addData.IMOCompanyId != null) {
                    this.state.addData.IMOCompanyId = this.state.addData.IMOCompanyId.trim();
                }
                if (this.state.addData.PhoneNumber != "" || this.state.addData.PhoneNumber != null) {
                    this.state.addData.PhoneNumber = this.state.addData.PhoneNumber.trim();
                }
                if (this.state.addData.Builder != "" || this.state.addData.Builder != null) {
                    this.state.addData.Builder = this.state.addData.Builder.trim();
                }
                this.setState({})
                if (this.state.isEdit == false) {
                    if (this.state.addData.Id != 0) {
                        this.setState({ cancel: false })
                        this.props.dispatch({ type: "CANCEL", data: false });
                        this.props.dispatch(putprojectshipinfo(this.state.addData, this.state.addData.Id))
                    }
                    else {
                        this.props.dispatch({ type: "CANCEL", data: false });
                        this.addprojectshipinfo(this.state.addData);
                    }
                }
                else {
                    if (this.state.addData.Id == 0 || this.state.addData.Id == undefined || this.state.addData.Id == "") {
                        this.setState({ cancel: false })
                        localStorage.setItem("EditID", this.state.addData.Id)
                        this.props.dispatch({ type: "CANCEL", data: false });
                        this.props.dispatch(addprojectshipinfo(this.state.addData));
                    }
                    else {
                        this.setState({ cancel: false })
                        this.props.dispatch({ type: "CANCEL", data: false });
                        this.props.dispatch(putprojectshipinfo(this.state.addData, this.state.addData.Id))
                    }
                }
            }
        }
    };
    addprojectshipinfo = (data) => {
        let apiUrl = API.ADDEDIT_SHIPINFO;
        
          this.props.dispatch({ type: "SHOW_LOADER", data: true })
          axios({
            method: "POST",
            url: apiUrl,
            data: data,
          })
            .then((response) => {
              this.props.dispatch({ type: "SHOW_LOADER", data: false })
              if (response?.status === 200) {
                this.state.addData.Id=response.data
                this.setState({})
              } else {
      
              }
            })
            .catch((error) => {
              this.props.dispatch({ type: "SHOW_LOADER", data: false })
              if (error?.response?.status === 401) {
              }
            });
      };
    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/projectlist`)
        }
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/projectlist`)
    };

    render() {
        const { isError1, isError2, isError3, isError4, isError5, isError6, isError7, isError8, isError9, isError10, isError11, isError12, isError13, isError14, isError15, addData, isEdit } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Ship" + "1"} className='textNaviIcon' primary={this.state.isEdit ? "Edit Project" : "New Project"} />
                                            <NavigateNextIcon id="Ship" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5">
                                    <h4 className="pt-2">Ship Particulars</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="text-center">
                                            <button className={`${classes.button} `} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td className="" width="95%">
                                                <button className={`${classes.button}`} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.ProjectName}</h6>}
                        <div className={this.state.isMobile ? "row mx-0 mt-2" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Name of Ship&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError1 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Name}
                                            onChange={(e) => { this.handleInputChange(e, "Name") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Name}
                                            onChange={(e) => { this.handleInputChange(e, "Name") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Ship Type&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError2 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Type}
                                            onChange={(e) => { this.handleInputChange(e, "Type") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Type}
                                            onChange={(e) => { this.handleInputChange(e, "Type") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Flag State & Port of Registry&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError3 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.PortOfRegistry}
                                            onChange={(e) => { this.handleInputChange(e, "PortOfRegistry") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.PortOfRegistry}
                                            onChange={(e) => { this.handleInputChange(e, "PortOfRegistry") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Ship Builder&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Builder}
                                        onChange={(e) => { this.handleInputChange(e, "Builder") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n2 d-flex float-end text-right"} >Year of Construction&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError4 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.ConstructionDate}
                                            onChange={(e) => { this.handleInputChange(e, "ConstructionDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.ConstructionDate}
                                            onChange={(e) => { this.handleInputChange(e, "ConstructionDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Classification Society&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError5 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.ClassificationSociety}
                                            onChange={(e) => { this.handleInputChange(e, "ClassificationSociety") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.ClassificationSociety}
                                            onChange={(e) => { this.handleInputChange(e, "ClassificationSociety") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Gross Tonnage&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError6 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.GrossTonnage}
                                            onChange={(e) => { this.handleInputChange(e, "GrossTonnage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.GrossTonnage}
                                            onChange={(e) => { this.handleInputChange(e, "GrossTonnage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Net Tonnage&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError7 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.NetTonnage}
                                            onChange={(e) => { this.handleInputChange(e, "NetTonnage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.NetTonnage}
                                            onChange={(e) => { this.handleInputChange(e, "NetTonnage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Light Ship Weight&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError8 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.LightShipWeight}
                                            onChange={(e) => { this.handleInputChange(e, "LightShipWeight") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.LightShipWeight}
                                            onChange={(e) => { this.handleInputChange(e, "LightShipWeight") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Length Overall&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError9 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Length}
                                            onChange={(e) => { this.handleInputChange(e, "Length") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Length}
                                            onChange={(e) => { this.handleInputChange(e, "Length") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Breadth&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError10 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Breath}
                                            onChange={(e) => { this.handleInputChange(e, "Breath") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Breath}
                                            onChange={(e) => { this.handleInputChange(e, "Breath") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Depth&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError11 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Depth}
                                            onChange={(e) => { this.handleInputChange(e, "Depth") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Depth}
                                            onChange={(e) => { this.handleInputChange(e, "Depth") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Design Draught&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError12 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.DesignDraught}
                                            onChange={(e) => { this.handleInputChange(e, "DesignDraught") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.DesignDraught}
                                            onChange={(e) => { this.handleInputChange(e, "DesignDraught") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>IMO Number&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError13 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.IMONumber}
                                            onChange={(e) => { this.handleInputChange(e, "IMONumber") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.IMONumber}
                                            onChange={(e) => { this.handleInputChange(e, "IMONumber") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Distinctive Number or Letters&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError14 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.DistinctiveNumber}
                                            onChange={(e) => { this.handleInputChange(e, "DistinctiveNumber") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.DistinctiveNumber}
                                            onChange={(e) => { this.handleInputChange(e, "DistinctiveNumber") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 float-end text-right"}>IMO Registered Owner Identification Number&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.IMORegisteredOwnerId}
                                        onChange={(e) => { this.handleInputChange(e, "IMORegisteredOwnerId") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>IMO Company Identification Number&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.IMOCompanyId}
                                        onChange={(e) => { this.handleInputChange(e, "IMOCompanyId") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Telephone Number&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.PhoneNumber}
                                        onChange={(e) => { this.handleInputChange(e, "PhoneNumber") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Email Address&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Email}
                                        onChange={(e) => { this.handleInputChange(e, "Email") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Date of Beaching&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError15 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            error
                                            value={this.state.addData.DateofBeaching && moment(this.state.addData.DateofBeaching).format("yyyy-MM-DD")}

                                            placeholder={this.state.addData.DateofBeaching && moment(this.state.addData.DateofBeaching).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "DateofBeaching") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            value={this.state.addData.DateofBeaching && moment(this.state.addData.DateofBeaching).format("yyyy-MM-DD")}

                                            placeholder={this.state.addData.DateofBeaching && moment(this.state.addData.DateofBeaching).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "DateofBeaching") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                        </div>
                        <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                            <div class="modal-dialog" role="document">
                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                    <div class="modal-body pb-0">
                                        <h1 className="text-center">
                                            <img src={del}></img>
                                        </h1>
                                        <div className="text-center">
                                            <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                    </div>
                                    <div class="modal-footer border-top-0 m-auto">
                                        <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                        <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        getshipinfo: state.AddNewProjectReducer.getshipinfo || [],
        getprojectid: state.AddNewProjectReducer.getprojectid || [],
        getbasicinfo: state.AddNewProjectReducer.getbasicinfo || [],
        settings: state.commonReducer.settings || [],
    };
}

AddSP.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddSP))
);